import dstyled from 'astroturf';
var ListItem = /*#__PURE__*/dstyled('li', null, {
  displayName: "ListItem",
  styles: require("./DocumentOutlineItem-ListItem.module.css"),
  attrs: null,
  vars: []
});
export default ListItem;